var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunApplication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-289 381 32 32",
    style: {
      enableBackground: "new -289 381 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AEA051;}\n\t.st1{fill:#FBF4B1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-273,412.2L-273,412.2L-273,412.2c-8.4,0-15.3-6.8-15.3-15.2c0-4.1,1.6-7.9,4.5-10.8 c2.9-2.9,6.7-4.4,10.8-4.4l0,0c8.4,0,15.3,6.8,15.3,15.3c0,4.1-1.6,7.9-4.5,10.8C-265.1,410.7-268.9,412.2-273,412.2z M-273,410.7 L-273,410.7c3.7,0,7.1-1.4,9.7-4c2.6-2.6,4-6,4-9.7c0-7.6-6.2-13.8-13.8-13.8l0,0c-3.7,0-7.1,1.4-9.7,4c-2.6,2.6-4,6-4,9.7 C-286.8,404.6-280.6,410.7-273,410.7L-273,410.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-276.7,403.2 -267.1,397 -276.7,390.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-276.7,403.9c-0.1,0-0.2,0-0.4-0.1c-0.2-0.1-0.4-0.4-0.4-0.7v-12.3c0-0.3,0.1-0.5,0.4-0.7 c0.2-0.1,0.5-0.1,0.8,0l9.6,6.2c0.2,0.1,0.3,0.4,0.3,0.6c0,0.3-0.1,0.5-0.3,0.6l-9.6,6.2C-276.4,403.9-276.5,403.9-276.7,403.9z  M-275.9,392.2v9.6l7.5-4.8L-275.9,392.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunApplication);
export default __webpack_public_path__ + "static/media/run_application.96db1dd3e2d795a01db9caade8c9b246.svg";
export { ForwardRef as ReactComponent };